import * as React from 'react'

import { cn } from '@/lib/utils'

/**
 * Caixa de seleção nativa, estilizada com `accent-color`.
 *
 * `accent-color` pinta o controle do sistema com a cor da marca sem reimplementar
 * o elemento — mantém o comportamento de teclado, o estado indeterminado e o
 * anúncio correto do leitor de tela. Um `<div role="checkbox">` custaria tudo
 * isso para ganhar um quadrado com o canto arredondado.
 */
export type CheckboxProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      type="checkbox"
      data-slot="checkbox"
      className={cn(
        'size-4 shrink-0 cursor-pointer rounded border-border bg-surface',
        'accent-[var(--color-primary)] focus-visible:outline-none',
        'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
)
Checkbox.displayName = 'Checkbox'

export { Checkbox }
